import { escapeHtml, renderDocument } from "./layout.js";
const ROWS = [
    ["personName", "M. / Mme (Nom et Prénom)", "الاسم واللقب"],
    ["fonction", "Fonction", "الوظيفة"],
    ["destination", "Destination (chantier / site)", "الوجهة (الورشة / الموقع)"],
    ["motif", "Motif de la mission", "موضوع المهمة"],
    ["transport", "Moyen de transport", "وسيلة النقل"],
    ["vehiclePlate", "Véhicule immatriculé N°", "رقم تسجيل المركبة"],
    ["accompaniedBy", "Accompagné(e) de", "مرفوق(ة) بـ"],
    ["departure", "Date et heure de départ", "تاريخ وساعة الذهاب"],
    ["returnAt", "Date et heure de retour", "تاريخ وساعة العودة"],
];
export function renderOrdreDeMission(entity, meta, d) {
    const rows = ROWS.map(([k, fr, ar]) => `<tr><td>${fr}</td><td><b>${escapeHtml(d[k] ?? "")}</b></td><td class="rtl">${ar}</td></tr>`).join("");
    const body = `
<p>Nous soussignés, Direction de l'entreprise, donnons ordre de mission à :</p>
<p class="rtl">نحن الممضون أسفله، إدارة المؤسسة، نكلف بمهمة السيد(ة) الآتي ذكره(ا) :</p>
<table class="data"><tbody>${rows}</tbody></table>
<p>Fait à ${escapeHtml(d.placeAndDate)}</p>
<p style="font-size:9pt;color:var(--ink2)">Le présent ordre de mission est valable uniquement pour la période et la destination indiquées.
<span class="rtl" style="display:block">هذا الأمر بمهمة صالح فقط للفترة والوجهة المذكورتين أعلاه.</span></p>
<div class="signatures">
  <div>L'intéressé(e) — المعني(ة) بالأمر<br>(Signature – الإمضاء)</div>
  <div>Le Directeur — المدير<br>(Signature et cachet – الإمضاء والختم)</div>
</div>
<div class="signatures" style="margin-top:8mm">
  <div>Visa d'arrivée à destination — تأشيرة الوصول إلى الوجهة<br>Cachet, date et signature</div>
  <div>Visa de retour — تأشيرة العودة<br>Cachet, date et signature</div>
</div>`;
    return renderDocument(entity, { ...meta, title: "Ordre de mission", titleAr: "أمر بمهمة", lang: "bilingual" }, body);
}
//# sourceMappingURL=ordre-de-mission.js.map